"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
var react_1 = require("@emotion/react");
var styled_1 = __importDefault(require("@emotion/styled"));
var colors_1 = require("./utils/colors");
var loadAnimation = (0, react_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n"], ["\n    0% {\n        transform: rotate(0deg);\n    }\n    100% {\n        transform: rotate(360deg);\n    }\n"])));
/**
 * Loading spinner for Button components
 * @param {string} primaryColor - Primary color used for the spinner animation
 * @param {string} size - Width/Height of the spinner
 */
exports.Spinner = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  top: calc(50% - ", "px);\n  left: calc(50% - ", "px);\n  border: 4px solid\n    ", ";\n  border-left: 4px solid ", ";\n  animation: ", " 1s infinite linear;\n  border-radius: 50%;\n  width: ", "px;\n  height: ", "px;\n"], ["\n  position: absolute;\n  top: calc(50% - ", "px);\n  left: calc(50% - ", "px);\n  border: 4px solid\n    ", ";\n  border-left: 4px solid ", ";\n  animation: ", " 1s infinite linear;\n  border-radius: 50%;\n  width: ", "px;\n  height: ", "px;\n"])), function (_a) {
    var size = _a.size;
    return size - 2;
}, function (_a) {
    var size = _a.size;
    return size - 2;
}, function (_a) {
    var primaryColor = _a.primaryColor;
    return "rgba(".concat((0, colors_1.hexToRGB)(primaryColor).toString(), ", 0.2)");
}, function (_a) {
    var primaryColor = _a.primaryColor;
    return primaryColor;
}, loadAnimation, function (_a) {
    var size = _a.size;
    return size;
}, function (_a) {
    var size = _a.size;
    return size;
});
var templateObject_1, templateObject_2;
